import type { BookableSession } from "./bookable-session";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isBookableSession = (input: any): input is BookableSession => {
    if (!input) return false;
    return input?._type === "BOOKABLE_SESSION";
};

export { isBookableSession };
